"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerAdminProfileUpdateTransport = exports.HaulerAdminProfileCreateTransport = exports.AppAdminProfileUpdateTransport = exports.AppAdminProfileCreateTransport = exports.ProfileUserCreateTransport = exports.ProfileTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const nullable_1 = require("../common/nullable");
const announcement_transport_1 = require("./announcement-transport");
const completed_tutorials_app_transport_1 = require("./completed-tutorials-app-transport");
const completed_tutorials_web_transport_1 = require("./completed-tutorials-web-transport");
const last_release_notes_transport_1 = require("./last-release-notes-transport");
exports.ProfileTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    active: typebox_1.Type.Boolean(),
    firstName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    lastName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    fullName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    phoneNumber: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    username: typebox_1.Type.String(),
    email: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    slackId: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    notificationPreferences: typebox_1.Type.Object({
        textOk: typebox_1.Type.Boolean(),
        emailOk: typebox_1.Type.Boolean(),
    }),
    authorities: typebox_1.Type.Array(typebox_1.Type.Object({
        id: typebox_1.Type.String({ format: 'uuid' }),
        active: typebox_1.Type.Boolean(),
        haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        contactID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        haulerName: typebox_1.Type.Optional(typebox_1.Type.String()),
        applicationName: typebox_1.Type.String(),
        roles: typebox_1.Type.Array(typebox_1.Type.String()),
    })),
    unseenAnnouncements: typebox_1.Type.Optional(typebox_1.Type.Array(announcement_transport_1.AnnouncementTransport)),
    completedTutorialsApp: typebox_1.Type.Optional(completed_tutorials_app_transport_1.CompletedTutorialsAppTransport),
    completedTutorialsWeb: typebox_1.Type.Optional(completed_tutorials_web_transport_1.CompletedTutorialsWebTransport),
    lastReleaseNotes: typebox_1.Type.Optional((0, nullable_1.Nullable)(last_release_notes_transport_1.LastReleaseNotesTransport)),
    lastLogin: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    metadata: common_1.MetaData,
});
exports.ProfileUserCreateTransport = typebox_1.Type.Object({
    firstName: typebox_1.Type.String(),
    lastName: typebox_1.Type.String(),
    email: typebox_1.Type.String({ format: 'email' }),
    phoneNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    slackId: typebox_1.Type.Optional(typebox_1.Type.String()),
    roles: typebox_1.Type.Array(typebox_1.Type.String()),
});
exports.AppAdminProfileCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.ProfileTransport, ['username', 'email', 'firstName', 'lastName', 'phoneNumber', 'active', 'slackId']),
    typebox_1.Type.Object({
        roles: typebox_1.Type.Array(typebox_1.Type.String()),
    }),
]);
exports.AppAdminProfileUpdateTransport = typebox_1.Type.Partial(exports.AppAdminProfileCreateTransport);
exports.HaulerAdminProfileCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        tempPassword: typebox_1.Type.Optional(typebox_1.Type.String()),
        email: typebox_1.Type.Optional(typebox_1.Type.String()),
        username: typebox_1.Type.Optional(typebox_1.Type.String()),
        roles: typebox_1.Type.Array(typebox_1.Type.String()),
    }),
    typebox_1.Type.Pick(exports.ProfileTransport, ['username', 'email', 'firstName', 'lastName', 'phoneNumber']),
]);
exports.HaulerAdminProfileUpdateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        addRoles: typebox_1.Type.Array(typebox_1.Type.String()),
        removeRoles: typebox_1.Type.Array(typebox_1.Type.String()),
    }),
    typebox_1.Type.Partial(typebox_1.Type.Pick(exports.ProfileTransport, ['email', 'firstName', 'lastName', 'phoneNumber', 'active'])),
]);
//# sourceMappingURL=profile-transport.js.map